// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"366":"b3238c2f","740":"92a17922","800":"0e1b6429","881":"01693352","945":"8a51b1f3"}[chunkId] + ".css";
};